import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const Input = styled.input`
  border: none;
  width: 100%;
  padding-right: 44px;
  height: 42px;
  padding: 0 40px 0 12px;
  padding-left: ${({ hasIcon }) => (hasIcon ? '40px' : '12px')};
  box-sizing: border-box;
  background-color: ${({ bgColor }) => bgColor};
  border: 1px solid ${({ bColor }) => bColor};
  border-radius: 4px;
`;

export const TextArea = styled.textarea`
  border: none;
  width: 100%;
  padding-right: 44px;
  min-height: 100px;
  padding: 12px 40px 12px 12px;
  padding-left: ${({ hasIcon }) => (hasIcon ? '40px' : '12px')};
  box-sizing: border-box;
  background-color: ${({ bgColor }) => bgColor};
  border: 1px solid ${({ bColor }) => bColor};
  border-radius: 4px;
  resize: none;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }
`;

export const InputIcon = styled.div`
  position: absolute;
  top: 1px;
  left: 1px;
  height: 40px;
  width: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
`;

export const ClearButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  position: absolute;
  top: 1px;
  right: 1px;
  height: 40px;
  width: 40px;
  border-radius: 20px;
  font-size: 14px;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ color }) => color};
`;
